import { render } from "./FormNumberRow.vue?vue&type=template&id=1327900a"
import script from "./FormNumberRow.vue?vue&type=script&lang=js"
export * from "./FormNumberRow.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__